/** Phone mockup width in the template preview panel. */
export const PREVIEW_DEVICE_WIDTH = '340px';

/**
 * Max distance from the device edge to the center of side controls
 * (actions pill, stamp chevrons). Caps how far they drift on wide panels.
 */
export const PREVIEW_RAIL_MAX_OFFSET = '48px';

const previewRailOffset = `min((100% - ${PREVIEW_DEVICE_WIDTH}) / 4, ${PREVIEW_RAIL_MAX_OFFSET})`;

export const CENTER_OF_PREV_RAIL = '50%';

/** Horizontal center of the right-side controls rail. */
export const RIGHT_OF_PREV_RAIL_CENTRE = `calc(${CENTER_OF_PREV_RAIL} + (${PREVIEW_DEVICE_WIDTH} / 2) + ${previewRailOffset})`;

/** Horizontal center of the left-side controls rail. */
export const LEFT_OF_PREV_RAIL_CENTRE = `calc(${CENTER_OF_PREV_RAIL} - (${PREVIEW_DEVICE_WIDTH} / 2) - ${previewRailOffset})`;
